import { render, staticRenderFns } from "./CommitteeAdvanceCard.vue?vue&type=template&id=2a9aa6ca"
import script from "./CommitteeAdvanceCard.vue?vue&type=script&lang=js"
export * from "./CommitteeAdvanceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports